export const PRODUCT = "item";
export const RESTAURANT = "branch";

export const linkOf = (banner) => {
  if (!banner) return null;
  if (banner.item) return { type: PRODUCT, id: banner.item.id, name: banner.item.name };
  if (banner.branch) return { type: RESTAURANT, id: banner.branch.id, name: banner.branch.name };
  return null;
};

export const sameLink = (a, b) => Boolean(a && b && a.type === b.type && a.id === b.id);

export const startingChoice = (banner) => {
  if (banner && banner.item) return { type: PRODUCT, restaurant: banner.item.branch || null, product: banner.item };
  if (banner && banner.branch) return { type: RESTAURANT, restaurant: banner.branch, product: null };
  return { type: PRODUCT, restaurant: null, product: null };
};

export const chosenLink = ({ type, restaurant, product }) => {
  const target = type === PRODUCT ? product : restaurant;
  return target ? { type, id: target.id, name: target.name } : null;
};

export const missingChoice = ({ type, restaurant, product }) => {
  if (!restaurant) return "Pick a restaurant";
  if (type === PRODUCT && !product) return "Pick a product";
  return null;
};
